export default {
    GET_VOA_SUMMARY_SUCCESS: "[zina_flow][summary] get all voa summary SUCCESS",
    UPDATE_SUMMARY_PAGINATION: "[zina_flow][summary] update voa summary pagination",
    GET_VOA_SUMMARY_FAIL: "[zina_flow][summary] get all voa summary FAIL",
    GET_VOA_SUMMARY: "[zina_flow][summary] get all voa summary",
    FILTER_LIST_SUMMARY: "[zina_flow][summary] change voa summary filters",
    CHANGE_PAGE_SUMMARY: "[zina_flow][summary] change voa summary page"
};
